import { render, staticRenderFns } from "./SX320.vue?vue&type=template&id=58c459da&scoped=true&"
import script from "./SX320.vue?vue&type=script&lang=js&"
export * from "./SX320.vue?vue&type=script&lang=js&"
import style0 from "./SX320.vue?vue&type=style&index=0&id=58c459da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c459da",
  null
  
)

export default component.exports